import { Field } from "@progress/kendo-react-form";
import {
  FormDropDownList,
  FormNumericTextBox,
} from "../../../../forms/form-components";
import {
  getExcelSheetsFromFile,
  maxSize,
  setFormValue,
  setProcessing,
} from "../../../../redux/slices/importdatasetpageslice";
import { useDispatch, useSelector } from "react-redux";
import { FormRegion } from "../../../../components/formregion";
import { Button } from "@progress/kendo-react-buttons";
import { useCallback, useEffect, useState } from "react";
import { addNotification } from "../../../../redux/slices/notificationsslice";
import { notificationDurationMiddle } from "../../../../lib/utils";
import { apiErrorsHandler } from "../../../../api/httpclient";
import { useNavigate } from "react-router-dom";
import i18next from "i18next";
import { useTranslation } from "react-i18next";


const ImportFromFileStep = (props) => {
  //#region state
  const { formValues } = props;
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const pageState = useSelector((state) => state.importDatasetPage);
  const sheets = pageState.sheets;
  const currentUser = useSelector((state) => state.currentUser);
  const [localFile, setLocalFile] = useState(null);
  const { t } = useTranslation();
  //#endregion

  //#region functions
  useEffect(() => {
    if (pageState.formValues.File) {
      console.log("File is now available:", pageState.formValues.File);
    }
  }, [pageState.formValues.File]);

  const handleOnChangeField = useCallback(
    (id, value) => {
      dispatch(setFormValue({ id, value }));
    },
    [dispatch]
  );

  const getListOfSheets = async (file) => {
    dispatch(getExcelSheetsFromFile(file, currentUser, t)).catch((err) => {
      dispatch(setProcessing({ processing: false }));
      const errorHandler = (messages) => {
        const message = messages?.[0] || t("datasets.importdataset.unknown_error");
        dispatch(
          addNotification({
            text: message,
            type: "error",
            closable: true,
            duration: notificationDurationMiddle,
            position: "topRight",
          })
        );
      };
      apiErrorsHandler({}, dispatch, navigate, err, "/", {
        responseReceived: errorHandler,
        unhandled: errorHandler,
      });
    });
  };

  const handleOnFileChange = useCallback(
    (e) => {
      const file = e.target.files[0];
      if (!file) return;
      if (file.size > maxSize) {
        dispatch(
          addNotification({
            text: t("datasets.importdataset.size_error"),
            type: "error",
            closable: true,
            duration: notificationDurationMiddle,
            position: "topRight",
          })
        );
        return;
      }
      setLocalFile(file);
      dispatch(setFormValue({ id: "File", value: file }));
      dispatch(setFormValue({ id: "Filename", value: file.name }));
    },
    [dispatch]
  );

  function handleUploadExcelFile(e) {
    e.preventDefault();
    if (localFile !== null && pageState.formValues.Filename !== "") {
      const formData = new FormData();
      formData.append("file", localFile);
      getListOfSheets(formData);
    }
  }

  function handleOnSheetChange(e) {
    handleOnChangeField("SelectedSheet", e.value);
    handleOnChangeField("StartingRow", 2);
    handleOnChangeField("EndingRow", undefined);
    handleOnChangeField("IsDataReal", true);
  }

  //#endregion
  return (
    <FormRegion>
      <div className="form-group form-group-1">
        <div className="k-form-field">
          <label className="k-label k-text-disabled">{t("datasets.importdataset.selected")}</label>
          <div className="k-form-field-wrap">
            <input
              disabled={true}
              name="SelectedDataset"
              id="SelectedDataset"
              className="k-input k-input-md k-rounded-md k-input-solid"
              value={
                pageState.lst_of_datasets.find(
                  (option) =>
                    option.Id === Number(pageState.formValues.SelectedDataset)
                )?.Title
              }
              style={{ marginBottom: "15px" }}
            />
          </div>
        </div>
        <div
          style={{
            display: "flex",
            width: "100%",
            justifyContent: "space-between",
          }}
        >
          <div className="k-form-field">
            <label id="File_label" htmlFor="File" className="k-label">
              {t("datasets.importdataset.file")}
            </label>
            <div className="k-widget k-upload upload-file">
              <div className="k-dropzone">
                <div
                  role="button"
                  className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-base k-upload-button k-focus"
                  aria-label={t("datasets.importdataset.files")}
                  aria-labelledby="File_label"
                >
                  <input
                    autoComplete="off"
                    id="File"
                    name="File"
                    accept=".csv, .xlsx, .xls"
                    type="file"
                    title={t("datasets.importdataset.selectfile")}
                    onChange={handleOnFileChange}
                  />
                  <span>{t("datasets.importdataset.file1")}</span>
                </div>
                <div className="k-dropzone-hint">{t("datasets.importdataset.drop")}</div>
                {pageState.formValues.File && (
                  <ul
                    className="k-upload-files k-reset"
                    style={{
                      width: "100%",
                      position: "absolute",
                      top: "46px",
                      marginLeft: "-10px",
                    }}
                  >
                    <li
                      className="k-file"
                      data-uid={pageState.formValues.FileId}
                      tabIndex="-1"
                    >
                      <div className="k-file-single">
                        <div
                          className="k-progressbar"
                          style={{
                            transition: "opacity 1s ease-in-out",
                            opacity: "1",
                          }}
                        >
                          <span
                            className="k-progress"
                            style={{ width: "0%" }}
                          ></span>
                        </div>
                        <span className="k-file-group-wrapper">
                          <span className="k-file-group k-icon k-i-file-data"></span>
                          <span className="k-file-state"></span>
                        </span>
                        <span
                          className="k-file-name-size-wrapper"
                          style={{ textAlign: "left" }}
                        >
                          <span
                            className="k-file-name"
                            title={pageState.formValues.Filename}
                          >
                            {pageState.formValues.Filename}
                          </span>
                        </span>
                      </div>
                    </li>
                  </ul>
                )}
              </div>
            </div>
          </div>
          {pageState.formValues.File && (
            <Button onClick={handleUploadExcelFile} className={"upload-button"}>
              {t("datasets.importdataset.upload")}
            </Button>
          )}
        </div>
        {pageState.formValues.File && sheets.length > 0 && (
          <div style={{ marginTop: "70px" }}>
            <Field
              id={"SelectedSheet"}
              name={"SelectedSheet"}
              label={t("datasets.importdataset.sheets")}
              component={FormDropDownList}
              onChange={handleOnSheetChange}
              data={sheets}
            />
            <div className="rows-container">
              <Field
                id={"StartingRow"}
                name={"StartingRow"}
                label={t("datasets.importdataset.start")}
                component={FormNumericTextBox}
                onChange={(e) => handleOnChangeField("StartingRow", e.value)}
              />
              <Field
                id={"EndingRow"}
                name={"EndingRow"}
                label={t("datasets.importdataset.end")}
                component={FormNumericTextBox}
                onChange={(e) => handleOnChangeField("EndingRow", e.value)}
              />
            </div>
            <div style={{ width: "100%", marginBottom: "50px" }}>
              {t("datasets.importdataset.row1")}
              <br />
              {t("datasets.importdataset.row2")}
              <br />
              {t("datasets.importdataset.row3")}
              <br/>              
              {t("datasets.importdataset.row4")}
            </div>
          </div>
        )}
      </div>
      <style>
        {`        
            .datasets-page > .content .form-root .k-form .k-form-field{
              width:100%;
            } 
            .datasets-page .form-group .upload-button{    
              width: 15%;
              margin-left: 2%;
              height: 48px;
              margin-top: 25px;
            }
            .datasets-page .form-group .rows-container{
              display: flex; 
              justify-content:space-between ; 
              margin-top:20px;
              margin-bottom:50px;
            }
            .datasets-page .form-group .rows-container .k-form-field{
              width:48% !important;
            } 
            .datasets-page .form-group .rows-container .k-form-field:nth-child(2) {
                margin-top: 4px !important;
            }
            .datasets-page .form-group .rows-container .k-radio-list{
              display: flex; 
              flex-direction: row;
              justify-content:space-between ; 
              margin-top:0;
              margin-bottom:0;
            } 
            .datasets-page .form-group .import-checkbox{
              margin-bottom:20px;
              display:block;
            }
          `}
      </style>
    </FormRegion>
  );
};

export default ImportFromFileStep;
